import { Resource } from "i18next";
import t from "../../locales/ru.json";

export default t as Resource;
